import { Injectable } from '@angular/core';

export interface ToastConfig {
  className?: string;
  autoHideDelay?: number;
}
export class Toast {
  className: string;
  private _timeoutID;
  private _autoHideDelay: number;

  constructor( private _onDismissal: (toast: Toast) => void, public message: string, config: ToastConfig) {
    this.className = config.className;
    this.autoHideDelay = config.autoHideDelay;
  }

  get autoHideDelay(): number {
    return this._autoHideDelay;
  }

  set autoHideDelay(value: number) {
    this._autoHideDelay = value;
    this._clearTimeout();
    this._init();
  }

  hide() {
    this._clearTimeout();
  }

  private _init() {
    if (this.autoHideDelay && !this._timeoutID) {
      this._timeoutID = setTimeout(() => this.hide(), this.autoHideDelay);
    }
  }

  private _clearTimeout() {
    if (this._timeoutID) {
      clearTimeout(this._timeoutID);
      this._timeoutID = null;
      this._onDismissal(this);
    }
  }
}

@Injectable({ providedIn: 'root' })
export class ToastService {
  toasts: Toast[] = [];

  showToast(toast: Toast) {
    this.toasts.push(toast);
  }

  private show(message: string, config: ToastConfig) {
    const onDismissal = (toast: Toast) => this.remove(toast);
    this.showToast(new Toast(onDismissal, message, config));
  }

  remove(toast): void {
    this.toasts = this.toasts.filter(t => t !== toast);
  }

  removeAll(): void {
    this.toasts = [];
  }

  showStandard(message: string) {
    this.show(message, { autoHideDelay: 5000, className: "alert-light" });
  }

  showSuccess(message: string) {
    this.show(message, { autoHideDelay: 5000, className: 'alert-success'});
  }

  showWarning(message: string) {
    this.show(message, { autoHideDelay: 0, className: 'alert-success'});
  }

  showDanger(message:string, noSupportWarning?:boolean) {
    let result = message;
    if(!noSupportWarning) {
      if(!/[.?!;:]$/.test(result)) result += ".";
      result += " Please contact support.";
    }
    this.show(result, { autoHideDelay: 0, className: 'alert-danger' });
  }
}
